import React from 'react';
import './LoadingDots.css';

export type LoadingDotsProps = {
    /** Optional text before the dots (e.g. "Processing", "Loading"). */
    label?: string;
    className?: string;
};

/**
 * Animated ellipsis for long-running / polling UI so users feel activity
 * while jobs pull status (preview, send, background queues, etc.).
 *
 * @example
 * <h3><LoadingDots label="Processing" /></h3>
 * @example
 * Loading <LoadingDots />
 */
const LoadingDots = ({ label, className }: LoadingDotsProps) => (
    <span className={['loading-dots', className].filter(Boolean).join(' ')}>
        {label}
        <span className='loading-dots__anim' aria-hidden='true'>
            <span>.</span>
            <span>.</span>
            <span>.</span>
        </span>
    </span>
);

export default LoadingDots;
